import base from '../dr-base'
import drBaseActions from '../dr-base-actions'
import drButton from './dr-button.vue'

const schema = {
  $Type: 'dr-button',
  name: 'Button',
  group: 'Button widgets',
  icon: 'mouse-alt',
  ...base,
  properties: {
    ...base.properties,
    Disabled: {
      name: 'vuetifyWidgets.dr-button.disabled',
      type: 'string',
      default: ''
    },
    Caption: {
      name: 'vuetifyWidgets.dr-button.caption',
      type: 'string',
      default: 'Button'
    },
    Tooltip: {
      name: 'vuetifyWidgets.dr-button.tooltip',
      type: 'string',
      default: 'Button'
    },
    Color: {
      name: 'vuetifyWidgets.dr-button.color',
      type: 'string',
      default: '#2196f3',
      component: 'dr-color-picker'
    },
    IconMode: {
      name: 'vuetifyWidgets.dr-button.iconMode',
      type: 'boolean',
      enum: [ {
        value: true,
        text: 'vuetifyWidgets.dr-button.iconMode'
      } ,{
        value: false,
        text: 'vuetifyWidgets.dr-button.iconMode'
      }]
    },
    IconName: {
      name: 'vuetifyWidgets.dr-button.iconName',
      type: 'string',
      default: '',
      component: 'dr-icon-picker'
    },
    OnClickAction: {
      name: 'vuetifyWidgets.dr-button.onClickAction',
      type: 'object',
      component: 'dr-prop-action',
      properties: { 
        ...drBaseActions.properties.OnClickAction.properties,
        Type: {
          name: 'vuetifyWidgets.dr-button.type',
          type: 'string',
          enum: [
            ...drBaseActions.properties.OnClickAction.properties.Type.enum,
            {
              value: 'PopUpMenu',
              text: 'vuetifyWidgets.drPropAction.popUpMenu'
            },
            {
              value: 'ExtendedPopUpMenu',
              text: 'vuetifyWidgets.drPropAction.extendedPopUpMenu'
            }
          ]
        } 
      }
    },
    ButtonType: {
      name: 'vuetifyWidgets.dr-button.buttonType',
      type: 'string',
      enum: [{
        value: 'simple',
        text: 'vuetifyWidgets.dr-button.simple'
      } ,{
        value: 'toogle',
        text: 'vuetifyWidgets.dr-button.toogle'
      }]
    },
    isRounded: {
      name: 'Rounded',
      type: 'boolean',
      default: false
    },
    isOutlined: {
      name: 'Outlined',
      type: 'boolean',
      default: false
    },
    isPlain: {
      name: 'Plain',
      type: 'boolean',
      default: false
    },
    isRaised: {
      name: 'Raised',
      type: 'boolean',
      default: false
    },
    isText: {
      name: 'Text',
      type: 'boolean',
      default: false
    }
  }
}

export default {
  schema,
  component: drButton,
  propEditors: [
    {
      name: 'dr-prop-action'
    },
    {
      name: 'dr-icon-picker'
    },
    {
      name: 'dr-color-picker'
    }
  ]
}

